export const ESP_REQUEST_FORM_KEY = 'espRequestForm'
export const ESP_ACTIVITY_FORM_KEY = 'espActivityForm'
export const ESP_REJECT_FORM_KEY = 'espRejectForm'
export const ESP_SPONSOR_FORM_KEY = 'espSponsorForm'

// The ESP Portal's Quick check-in mail template, linked from the hint under "Notes and decisions".
export const ESP_QUICK_CHECK_IN_URL =
  'https://hp.sharepoint.com/sites/coexecutivesponsorprogram/Shared%20Documents/Quick%20check-in.msg'
